import { getData, postData, putData } from "../axiosConfig"


export const getUserSale = async () => {
    return await getData(`admin/user-sell`)
}

export const getUserVoucher = async () => {
    return await getData(`admin/discount-vouchers`)
}


export const userNotice = async (body) => {
    return await postData(`admin/notification`, body)
}
export const allUserNotice = async () => {
    return await getData(`admin/notification`)
}
export const addNotes = async (id, body) => {
    return await putData(`admin/voucher-update/${id}`, body)
}

